<script lang="ts">
import { Button} from "sveltestrap";
import { href, NEWMAIL } from "../../../../utils/Constant/Constant";
import data from "../../../../Data/Email/Email.json"
import Link from "svelte-link";
import EmailSidebarTab from "./EmailSidebarTab.svelte";
</script>
<ul class="nav main-menu" role="tablist">
    <li class="nav-item">
        <Button color="primary" class="btn-block btn-mail w-100" href={href} >
            <i class="icofont icofont-envelope me-2"></i> {NEWMAIL}
        </Button>
    </li>
    <EmailSidebarTab />
    <li>
        <hr>
    </li>
    {#each data.emailappfilter2data as emailItem}
        <li>
            <Link href={href}>
                <span class="title"><i class={emailItem.icon}></i> {emailItem.name}</span>
                {#if emailItem.badge}
                    <span class="badge pull-right">{emailItem.badge}</span>
                {/if}
            </Link>
        </li>
    {/each}
</ul>